import { SideBarActions } from '../ActionTypes';

export const setSelectedItem = (selectedItem) => ({
    type: SideBarActions.SetSelectedItem,
    selectedItem
});
